import React, { useEffect } from 'react';
import { SignIn } from '@clerk/clerk-react';
import SeoHead from "../components/SeoHead";
import { useI18n } from "../i18n/i18n";
import { AUTH_INTENT_STORAGE_KEY } from "../utils/analytics";

export default function AuthSignin() {
  const { t, localizePath } = useI18n();

  useEffect(() => {
    window.sessionStorage.setItem(AUTH_INTENT_STORAGE_KEY, "sign_in");
  }, []);

  return (
    <div className="pageContainer" style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <SeoHead
        title={t("auth.signInTitle")}
        description={t("auth.signInDescription")}
        canonicalPath={localizePath("/sign-in")}
        noIndex={true}
      />
      <h1 style={{ position: "absolute", left: "-9999px" }}>{t("auth.signInHeading")}</h1>
      <SignIn
        routing="path"
        path={localizePath("/sign-in")}
        signUpUrl={localizePath("/sign-up")}
        afterSignInUrl={localizePath("/")}
      />
    </div>
  );
}
